module.exports = __webpack_public_path__ + "assets/img/62095f42aa7d432513a51f11bb7fa4b6.svg";